@if(roleForm()){
<form [formGroup]="roleForm()">
    <div class="row mb-3">
        <div class="col-md-4 mb-3">
            <div class="form-group">
                <label class="form-label">Slug (código)</label>
                @if(mode() === formMode.CREATE || mode() === formMode.EDIT){
                <input type="text" class="form-control text-uppercase" formControlName="name"
                    placeholder="EJ: SOCIO, SEC_UCH"
                    (input)="onNameInput($event)"
                    autocomplete="off">
                <div class="form-text">Identificador técnico en MAYÚSCULAS (solo A-Z, 0-9 y _).</div>
                }@else{
                <div class="form-control-plaintext">
                    <strong>{{roleForm().get('name')?.value}}</strong>
                </div>
                }
            </div>
        </div>
        <div class="col-md-4 mb-3">
            <div class="form-group">
                <label class="form-label">Nombre para mostrar</label>
                @if(mode() === formMode.CREATE || mode() === formMode.EDIT){
                <input type="text" class="form-control" formControlName="displayName">
                }@else{
                <div class="form-control-plaintext">
                    <strong>{{roleForm().get('displayName')?.value}}</strong>
                </div>
                }
            </div>
        </div>
        <div class="col-md-4 mb-3">
            <div class="form-group">
                <label class="form-label">Categoría</label>
                @if(mode() === formMode.CREATE || mode() === formMode.EDIT){
                <select class="form-select" formControlName="category">
                    <option [ngValue]="null">Sin categoría</option>
                    <option value="USER">Usuario / Socio</option>
                    <option value="FINANZAS">Finanzas</option>
                    <option value="SECRETARIA">Secretaría</option>
                    <option value="ADMINISTRACION">Administración</option>
                </select>
                }@else{
                <div class="form-control-plaintext">
                    <strong>{{ categoryLabel(roleForm().get('category')?.value) }}</strong>
                </div>
                }
            </div>
        </div>
        <div class="col-md-4 mb-3">
            <div class="form-group">
                <label class="form-label">Nivel de Privilegios</label>
                @if(mode() === formMode.CREATE || mode() === formMode.EDIT){
                <input type="number" class="form-control" formControlName="level"
                    placeholder="0 = SuperAdmin, mayor = menos privilegios">
                }@else{
                <div class="form-control-plaintext">
                    <strong>{{roleForm().get('level')?.value}}</strong>
                </div>
                }
            </div>
        </div>
        <div class="col-md-8 mb-3">
            <div class="form-group">
                <label class="form-label">Descripción</label>
                @if(mode() === formMode.CREATE || mode() === formMode.EDIT){
                <input type="text" class="form-control" formControlName="description">
                }@else{
                <div class="form-control-plaintext">
                    <strong>{{roleForm().get('description')?.value}}</strong>
                </div>
                }
            </div>
        </div>
    </div>
    @if(mode() === formMode.VIEW){
    <div class="row">
        <div class="col-12 d-flex justify-content-end gap-2">
            @if (perm.canCurrent('canUpdate')) {
            <button type="button" class="btn btn-outline-primary btn-sm" (click)="editMode()">
                <i class="fas fa-edit"></i> Editar
            </button>
            }
            @if (perm.canCurrent('canUpdate')) {
            @if(roleForm().get('isActive')?.value){
            <button type="button" class="btn btn-outline-secondary btn-sm" (click)="updateStatus(false)">
                <i class="fas fa-times"></i> Desactivar
            </button>
            }@else{
            <button type="button" class="btn btn-outline-secondary btn-sm" (click)="updateStatus(true)">
                <i class="fas fa-check"></i> Activar
            </button>
            }
            }
        </div>
    </div>
    }
</form>
<ng-content></ng-content>
}